export default __webpack_public_path__ + "669b168c44b919b3698b88b4c03ecf41.png";